module.exports = __webpack_public_path__ + "static/media/FlexwindLogo.89efe30b.png";